import { useState } from "react";
import { supabase } from "./supabaseClient";

const NAVY_DARK = "#111D33";
const ACCENT = "#D20A11";

export default function SetPasswordScreen({ user, onComplete }) {
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const handleSetPassword = async () => {
    if (!password || password.length < 8) {
      setError("Passwort muss mindestens 8 Zeichen haben."); return;
    }
    if (password !== confirm) {
      setError("Passwörter stimmen nicht überein."); return;
    }
    setLoading(true);
    setError("");

    const { error } = await supabase.auth.updateUser({ password });

    if (error) {
      setError(`Fehler: ${error.message}`);
    } else {
      onComplete();
    }
    setLoading(false);
  };

  return (
    <div style={{ minHeight: "100vh", background: NAVY_DARK, display: "flex", alignItems: "center", justifyContent: "center", fontFamily: "'Arial', sans-serif", padding: 24 }}>
      <div style={{ width: "100%", maxWidth: 400 }}>

        <div style={{ textAlign: "center", marginBottom: 40 }}>
          <div style={{ fontSize: 11, letterSpacing: 6, color: "rgba(255,255,255,0.4)", textTransform: "uppercase", marginBottom: 8 }}>FC Basel 1893</div>
          <div style={{ fontSize: 36, fontWeight: 900, color: "#fff", letterSpacing: 2, textTransform: "uppercase", lineHeight: 1 }}>PRO-TRACK</div>
          <div style={{ width: 40, height: 3, background: ACCENT, margin: "12px auto 0" }} />
        </div>

        <div style={{ background: "rgba(255,255,255,0.05)", border: "1px solid rgba(255,255,255,0.1)", borderRadius: 14, padding: "32px 28px" }}>
          <div style={{ fontSize: 16, fontWeight: 900, color: "#fff", marginBottom: 6, textTransform: "uppercase", letterSpacing: 1 }}>Passwort setzen</div>
          <div style={{ fontSize: 12, color: "rgba(255,255,255,0.4)", marginBottom: 24 }}>Willkommen! Bitte setze dein persönliches Passwort.</div>

          {error && (
            <div style={{ background: `${ACCENT}22`, border: `1px solid ${ACCENT}`, borderRadius: 8, padding: "10px 14px", marginBottom: 16, fontSize: 12, color: "#fff" }}>
              {error}
            </div>
          )}

          <div style={{ marginBottom: 14 }}>
            <div style={{ fontSize: 10, color: "rgba(255,255,255,0.4)", letterSpacing: 2, textTransform: "uppercase", marginBottom: 6, fontWeight: 700 }}>Neues Passwort</div>
            <input
              type="password"
              value={password}
              onChange={e => setPassword(e.target.value)}
              placeholder="Mindestens 8 Zeichen"
              style={{ width: "100%", padding: "12px 14px", borderRadius: 8, background: "rgba(255,255,255,0.08)", border: "1px solid rgba(255,255,255,0.15)", color: "#fff", fontSize: 14, outline: "none", boxSizing: "border-box" }}
            />
          </div>

          <div style={{ marginBottom: 24 }}>
            <div style={{ fontSize: 10, color: "rgba(255,255,255,0.4)", letterSpacing: 2, textTransform: "uppercase", marginBottom: 6, fontWeight: 700 }}>Passwort bestätigen</div>
            <input
              type="password"
              value={confirm}
              onChange={e => setConfirm(e.target.value)}
              onKeyDown={e => e.key === "Enter" && handleSetPassword()}
              placeholder="Passwort wiederholen"
              style={{ width: "100%", padding: "12px 14px", borderRadius: 8, background: "rgba(255,255,255,0.08)", border: "1px solid rgba(255,255,255,0.15)", color: "#fff", fontSize: 14, outline: "none", boxSizing: "border-box" }}
            />
          </div>

          <button onClick={handleSetPassword} disabled={loading} style={{
            width: "100%", padding: "14px",
            background: loading ? "rgba(210,10,17,0.5)" : ACCENT,
            border: "none", borderRadius: 8, color: "#fff",
            fontSize: 12, fontWeight: 900, cursor: loading ? "not-allowed" : "pointer",
            letterSpacing: 3, textTransform: "uppercase",
          }}>
            {loading ? "..." : "Passwort speichern →"}
          </button>
        </div>
      </div>
    </div>
  );
}
